var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "remastered-dialog",
    {
      attrs: {
        title: _vm.$t("whiteList.login"),
        blurred: _vm.accessDeniedDialog,
      },
      scopedSlots: _vm._u([
        {
          key: "after",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass: "dialog-denied",
                  class: { visible: _vm.accessDeniedDialog },
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("whiteList.warnTitle")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("whiteList.warnContent")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.accessDeniedDialog = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("confirm")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.error
        ? _c("div", { staticClass: "error" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("whiteList.error")) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          attrs: { "label-position": "top", model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "username", label: _vm.$t("general.username") } },
            [
              _c("el-input", {
                attrs: {
                  name: "username",
                  placeholder: _vm.$t("general.username"),
                },
                model: {
                  value: _vm.form.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "username", $$v)
                  },
                  expression: "form.username",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "password", label: _vm.$t("general.password") } },
            [
              _c("el-input", {
                attrs: {
                  name: "password",
                  placeholder: _vm.$t("general.password"),
                  "show-password": "",
                  password: "",
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { staticClass: "login-helper" }, [
            _c(
              "div",
              { staticClass: "items" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.isKeepLogin,
                      callback: function ($$v) {
                        _vm.isKeepLogin = $$v
                      },
                      expression: "isKeepLogin",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("vrlounge.keepLogin")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  { attrs: { href: _vm.forgotPasswordUrl, target: "_blank" } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("general.forgetPassword")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "submit-button" },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("general.login")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }